import i18n from '~/i18n';
import { registerEmailRule, registerNumberRule, registerTelephoneRule, registerUrlRule } from '~/utils/ruleUtil';
import { Form } from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';

class CommandActionForm extends Form {
  constructor(data, options) {
    super(data, options);
  }

  options() {
    return {
      validateOnInit: true,
      validateOnChange: true,
      validateOnBlur: false,
    };
  }

  /*
    Below we are returning a `plugins` object using the `validatorjs` package
    to enable `DVR` functionalities (Declarative Validation Rules).
  */
  plugins() {
    return {
      dvr: dvr({
        package: validatorjs,
        extend: ({ validator }) => {
          const messages = validator.getMessages('en');
          messages['required.title'] = i18n.t('form.rule.title.required', '제목을 입력해 주세요.');
          messages.max = i18n.t('form.rule.max', ':max자 이하로 입력해 주세요.');
          registerEmailRule(validator);
          registerNumberRule(validator);
          registerTelephoneRule(validator);
          registerUrlRule(validator);

          validator.setMessages('en', messages);
        },
      }),
    };
  }
}

export default CommandActionForm;
